<template>
  <div class="input-checked-list">
    <label for>{{label}}</label>
    <div class="checked-list" v-if="items && items.length > 0">
      <input type="hidden" v-model="value" />
      <div
        class="checked-item"
        v-for="(lst, key) in items"
        :key="key"
        @click="checkItem(lst.risklevel)"
      >
        <div class="checked-box" :class="{active: lst.risklevel == value}">
          <h4 v-html="lst.label" />
          <p v-html="lst.desc" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    items: {
      type: Array,
      default: null
    },
    label: {
      type: String,
      default: ""
    },
    default: {
      type: Number,
      default: null
    },
    name: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      checkedValue: "",
      value: this.default
    };
  },
  watch: {
    value: function(v) {
      this.$emit("input-checked-list", parseInt(v), this.name);
    }
  },
  methods: {
    checkItem(risklevel) {
      this.value = risklevel;
    }
  }
};
</script>
<style lang="scss" scoped>
.input-checked-list {
  label {
    margin-top: 32px;
    margin-left: 8px;
    display: block;
    font-size: 16px;
    font-weight: bold;
    color: #444444;
  }
  .checked-list {
    display: block;
    margin: 20px 0 70px 0;
    .checked-item {
      display: inline-block;
      width: 50%;
      padding: 8px;
      .checked-box {
        display: block;
        text-align: center;
        padding: 20px 0;
        border-radius: 4px;
        border: solid 1px $color-border;
        h4 {
          display: block;
          margin: 0;
          font-size: 16px;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: normal;
          letter-spacing: normal;
          text-align: center;
          color: #4a4a4a;
        }
        p {
          display: block;
          margin: 0;
          font-size: 14px;
          color: #999999;
        }
      }
      .active {
        border: solid 1px $color-primary-finno;
        position: relative;
        &:before {
          font-family: "Font Awesome 5 Pro";
          content: "\f00c";
          font-size: 10px;
          padding: 4px;
          background-color: $color-primary-finno;
          color: $color-white;
          border-radius: 50%;
          position: absolute;
          top: 9px;
          left: 9px;
        }
      }
    }
  }
}
</style>

